import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgGezinMetEenKind = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M11.45 20a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="M11.45 20a6 6 0 0 0-6 6v8h12v-8a6 6 0 0 0-6-6"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      d="M28.55 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="M28.55 18a6 6 0 0 1 6 6v10h-12V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M8.743 17.615a4.02 4.02 0 0 1-1.31-2.562l.994-.106a3.02 3.02 0 0 0 6.006 0l.994.106a4.02 4.02 0 0 1-6.684 2.562M25.567 12.947a3.02 3.02 0 0 0 6.006 0l.994.106a4.02 4.02 0 0 1-7.994 0z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M22.52 26a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M26.58 30a4 4 0 0 0-8 0v4h8z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgGezinMetEenKind);

export default ForwardRef;
